import type React from 'react';

export const FreeTrialActionButtons: React.FC<{ subscriptionCode: string }> = ({ subscriptionCode: _subscriptionCode }) => null;
